"use strict";
import { createContext, useContext } from "react";
import {
  APP_TABS,
  ModalState,
  SelectionModalMode,
  useLendingState
} from "../hooks/lendingState";
const LendingContext = createContext(void 0);
export const LendingStateProvider = ({ children }) => {
  const lendingState = useLendingState();
  return <LendingContext.Provider value={lendingState}>{children}</LendingContext.Provider>;
};
export const useLendingContext = () => {
  const context = useContext(LendingContext);
  if (context === void 0) {
    throw new Error("useLendingContext must be used within a LendingStateProvider");
  }
  return context;
};
export { APP_TABS, ModalState, SelectionModalMode };
